import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { Box, styled } from '@mui/material';

import { useUserContext } from '../../../contexts/user';

import Routes from '../../routes';

import styles from './styles';
import { useAnalyticsContext } from '../../../contexts/analytics';

const AppRaw = ({ className }) => {
  const { userIsLogged } = useUserContext();
  const {
    hotJar: { initHotjar },
  } = useAnalyticsContext();

  useEffect(() => {
    initHotjar();
  }, []);

  const boxClasses = {
    [className]: className,
    'dn-public': !userIsLogged(),
    'dn-private': userIsLogged(),
  };

  return (
    <Box className={boxClasses}>
      <Routes />
    </Box>
  );
};

const App = styled(AppRaw)`
  ${styles}
`;

AppRaw.propTypes = {
  className: PropTypes.string,
};

App.propTypes = AppRaw.propTypes;

export default App;
